import { useNotifications } from '../../context';
import { NotificationModal } from './NotificationModal';

export function NotificationDisplay() {
  const { currentNotification, dismissNotification } = useNotifications();

  return (
    <NotificationModal
      visible={!!currentNotification}
      title={currentNotification?.title ?? ''}
      body={currentNotification?.body ?? ''}
      onDismiss={dismissNotification}
    />
  );
}

export default NotificationDisplay;
